import { isServer } from '@vue-storefront/core/helpers'

export default {
  data () {
    return {
      productPageRoutes: [
        'product',
        'virtual-product',
        'bundle-product',
        'simple-product',
        'downloadable-product',
        'grouped-product',
        'configurable-product'
      ],
      isProductPage: false,
      isCheckoutPage: false,
      isCategoryPage: false,
      isHomePage: false,
      isMyAccount: false,
      isThankYouPage: false,
      isThankYouForSellingPage: false
    }
  },
  watch: {
    '$route.name': function () {
      this.setCurrentPage()
    }
  },
  computed: {
    canGoBack () {
      return !this.isHistoryEmpty() && this.isProductPage
    }
  },
  created () {
    this.setCurrentPage()
  },
  methods: {
    setCurrentPage () {
      this.isProductPage = !!this.$route.params.parentSku
      this.isCheckoutPage = this.$route.name.includes('checkout')
      this.isCategoryPage = this.$route.name && this.$route.name.includes('urldispatcher') && !this.isProductPage
      this.isHomePage = this.$route.name.includes('home')
      this.isMyAccount = this.$route.path.includes('my-account')
      this.isCmsPage = this.$route.path.includes('/i')
      this.isThankYouPage = this.$route.name.includes('thank-you-page')
      this.isThankYouForSellingPage = this.$route.name.includes('thank-you-for-selling-page')
      this.isSellingPage = this.$route.name.includes('selling')
    },
    currentPage () {
      if (this.isProductPage) {
        return 'product'
      } else if (this.isCheckoutPage) {
        return 'checkout'
      } else if (this.isCategoryPage) {
        return 'category'
      } else if (this.isHomePage) {
        return 'homepage'
      } else if (this.isMyAccount) {
        return 'my-account'
      } else if (this.isThankYouPage) {
        return 'thank-you-page'
      } else if (this.isThankYouForSellingPage) {
        return 'thank-you-for-selling-page'
      } else if (this.isSellingPage) {
        return 'selling'
      } else {
        return 'unknown'
      }
    },
    // Check if history is empty
    isHistoryEmpty () {
      if (!isServer) {
        return window.history.length <= 1
      }

      return false
    }
  }
}
